<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/welcometop.png" class="img" />
        <img src="../../assets/images/hynewtext.png" class="guanggaoimg" />
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'welcome',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}
</style>